import { render, staticRenderFns } from "./BranchesListView.vue?vue&type=template&id=6acec36d"
import script from "./BranchesListView.vue?vue&type=script&lang=js"
export * from "./BranchesListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports